export default {
  list: { lazy: () => import('./Distributors'), component: 'DistributorList' },
  edit: { lazy: () => import('./Distributors'), component: 'DistributorEdit' },
  create: { lazy: () => import('./Distributors'), component: 'DistributorCreate' },
}
